import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { ExclusionList } from '../models/exclusion-list';

@Injectable({
  providedIn: 'root'
})
export class ExclusionsListService {

  apiUrl = 'https://data2.ifa.com/'

  constructor(private http: HttpClient) { }
  
  getExclusionsList(query="") : Observable<ExclusionList[]> {
    let url = `${this.apiUrl}odata/v1/html_snippets/`
    url+= "?$filter=description eq 'Investing For Catholics Screens'"
    url+= query
    return this.http.get<ExclusionList[]> (url)
  }

}
